// @flow
import update from 'immutability-helper';
import unconfirmedPaymentReducer, {
  initialState as UnconfirmedPaymentInitialState,
  actions as UnconfirmedPaymentActions,
} from './unconfirmed-payment/duck';
import lookingForTravelerReducer, {
  initialState as LookingForTravelerInitialState,
  actions as LookingForTravelerActions,
} from './looking-for-traveler/duck';
import registerPurchaseReducer, {
  initialState as RegisterPurchaseInitialState,
  actions as RegisterPurchaseActions,
} from './register-purchase/duck';
import courierFlowReducer, {
  initialState as CourierFlowInitialState,
  actions as CourierFlowActions,
} from './courier-flow/duck';
import inTransitReducer, {
  initialState as InTransitInitialState,
  actions as InTransitActions,
} from './in-transit/duck';
import feedbackReducer, {
  initialState as FeedbackInitialState,
  actions as FeedbackActions,
} from './feedback/duck';

import type { UnconfirmedPaymentState } from './unconfirmed-payment/duck';
import type { LookingForTravelersState } from './looking-for-traveler/duck';
import type { RegisterPurchaseState } from "./register-purchase/duck";
import type { CourierFlowState } from './courier-flow/duck';
import type { InTransitState } from './in-transit/duck';
import type { FeedbackState } from './feedback/duck';

type PurchaseAction = {
  +type: string;
};

export type PurchaseState = {
  +unconfirmedPayment: UnconfirmedPaymentState;
  +lookingForTraveler: LookingForTravelersState;
  +registerPurchase: RegisterPurchaseState;
  +courierFlow: CourierFlowState;
  +inTransit: InTransitState;
  +feedback: FeedbackState;
};

// Actions

// Action Creators

export const initialState: PurchaseState = {
  unconfirmedPayment: UnconfirmedPaymentInitialState,
  lookingForTraveler: LookingForTravelerInitialState,
  registerPurchase: RegisterPurchaseInitialState,
  courierFlow: CourierFlowInitialState,
  inTransit: InTransitInitialState,
  feedback: FeedbackInitialState,
};

// Reducer
export default function reducer(state: PurchaseState = initialState,
                                action: PurchaseAction): PurchaseState {
  switch (action.type) {
    case LookingForTravelerActions.LOOKING_FOR_TRAVELERS_CANCEL_ORDER_REQUEST:
    case LookingForTravelerActions.LOOKING_FOR_TRAVELERS_CANCEL_ORDER_SUCCESS:
    case LookingForTravelerActions.LOOKING_FOR_TRAVELERS_CANCEL_ORDER_ERROR:
      return update(state, {
        lookingForTraveler: { $set: lookingForTravelerReducer((state: any).lookingForTraveler, (action: any)) },
      });
    case CourierFlowActions.COURIER_FLOW_POST_SET_TRACKING_NUMBER_REQUEST:
    case CourierFlowActions.COURIER_FLOW_POST_SET_TRACKING_NUMBER_SUCCESS:
    case CourierFlowActions.COURIER_FLOW_POST_SET_TRACKING_NUMBER_ERROR:
      return update(state, {
        courierFlow: { $set: courierFlowReducer((state: any).courierFlow, (action: any)) },
      });
    case InTransitActions.IN_TRANSIT_POST_CONFIRMATION_REQUEST:
    case InTransitActions.IN_TRANSIT_POST_CONFIRMATION_SUCCESS:
    case InTransitActions.IN_TRANSIT_POST_CONFIRMATION_ERROR:
      return update(state, {
        inTransit: { $set: inTransitReducer((state: any).inTransit, (action: any)) },
      });
    case RegisterPurchaseActions.REGISTER_PURCHASE_UPLOAD_INVOICE_FILE_REQUEST:
    case RegisterPurchaseActions.REGISTER_PURCHASE_UPLOAD_INVOICE_REQUEST:
    case RegisterPurchaseActions.REGISTER_PURCHASE_UPLOAD_INVOICE_SUCCESS:
    case RegisterPurchaseActions.REGISTER_PURCHASE_UPLOAD_INVOICE_ERROR:
    case RegisterPurchaseActions.REGISTER_PURCHASE_POST_IDENTITY_REQUEST:
    case RegisterPurchaseActions.REGISTER_PURCHASE_POST_IDENTITY_SUCCESS:
    case RegisterPurchaseActions.REGISTER_PURCHASE_POST_IDENTITY_ERROR:
    case RegisterPurchaseActions.REGISTER_PURCHASE_PROGRESS_PURCHASE_REQUEST:
    case RegisterPurchaseActions.REGISTER_PURCHASE_PROGRESS_PURCHASE_SUCCESS:
    case RegisterPurchaseActions.REGISTER_PURCHASE_PROGRESS_PURCHASE_ERROR:
      return update(state, {
        registerPurchase: { $set: registerPurchaseReducer((state: any).registerPurchase, (action: any)) },
      });
    case FeedbackActions.FEEDBACK_POST_FEEDBACK_REQUEST:
    case FeedbackActions.FEEDBACK_POST_FEEDBACK_SUCCESS:
    case FeedbackActions.FEEDBACK_POST_FEEDBACK_ERROR:
      return update(state, {
        feedback: { $set: feedbackReducer((state: any).feedback, (action: any)) },
      });
    case UnconfirmedPaymentActions.PURCHASE_UNCONFIRMED_PAYMENT_RESET_STATE:
    case UnconfirmedPaymentActions.PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_REQUEST:
    case UnconfirmedPaymentActions.PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_SUCCESS:
    case UnconfirmedPaymentActions.PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_ERROR:
      return update(state, {
        unconfirmedPayment: { $set: unconfirmedPaymentReducer((state: any).inTransit, (action: any)) },
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/duck.js